export default __webpack_public_path__ + "static/consistent-header-subnav-8851c9d0be72b72bec3b8900f27df827.png";